import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Path, { d: "M21 12a9 9 0 1 1-6.219-8.56", stroke: `${color}` })
    }
  );
};
Icon.displayName = "Loader2";
const Loader2 = memo(themed(Icon));
export {
  Loader2
};
//# sourceMappingURL=loader-2.js.map
